// Helper: converte URL relativa de upload (/uploads/community/xxx.png)
// pra absoluta apontando pro backend host. Sem esse prepend, o browser
// resolve a URL contra o frontend (admin.futezap.com.br ou
// comunidade.futezap.com.br) que devolve o index.html da SPA.
//
// URLs ja absolutas (http/https) e vazias/undefined passam intactas.
export function absoluteUploadUrl(url) {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  const host = getBackendHost();
  return `${host}${url.startsWith('/') ? '' : '/'}${url}`;
}

function getBackendHost() {
  // Prefere REACT_APP_BACKEND_URL. Fallback: deriva do REACT_APP_API_URL
  // (que termina em '/api').
  const explicit = process.env.REACT_APP_BACKEND_URL;
  if (explicit) return explicit.replace(/\/$/, '');
  const api = process.env.REACT_APP_API_URL || '';
  return api.replace(/\/api\/?$/, '');
}
